module.exports = new __parcel__URL__("connect_wallet_button.db787583.png").toString();